import React, { useState, useEffect } from 'react';
import companyService from '../../services/companyService';
import './CompanySubscription.css';

function CompanySubscription() {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSubscription();
  }, []);

  const loadSubscription = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await companyService.getSubscription();

      // API returns: {tier: "ENTERPRISE", maxUsers: -1, maxJobPostings: -1, ...}
      setSubscription(data);
    } catch (err) {
      console.error('Failed to load subscription:', err);
      setError(err.message || 'Failed to load subscription');
    } finally {
      setLoading(false);
    }
  };

  const formatLimit = (value) => {
    return value === -1 ? 'Unlimited' : value;
  };

  if (loading) {
    return (
      <div className="company-subscription">
        <h2>Subscription</h2>
        <div className="loading">Loading subscription info...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="company-subscription">
        <h2>Subscription</h2>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  if (!subscription) {
    return (
      <div className="company-subscription">
        <h2>Subscription</h2>
        <div className="error">No subscription data available</div>
      </div>
    );
  }

  return (
    <div className="company-subscription">
      <h2>Subscription</h2>
      <div className="plan-info">
        <h3>{subscription.tier || 'FREE'} Plan</h3>
        <p>Status: {subscription.isActive ? '✅ Active' : '❌ Inactive'}</p>
      </div>

      <div className="usage-section">
        {/* Max Users */}
        <div className="usage-item">
          <span>Max Users:</span>
          <span className="limit-value">{formatLimit(subscription.maxUsers)}</span>
        </div>

        {/* Max Job Postings */}
        <div className="usage-item">
          <span>Max Job Postings:</span>
          <span className="limit-value">{formatLimit(subscription.maxJobPostings)}</span>
        </div>

        {/* Max Candidates Per Month */}
        <div className="usage-item">
          <span>Max Candidates/Month:</span>
          <span className="limit-value">{formatLimit(subscription.maxCandidatesPerMonth)}</span>
        </div>
      </div>

      {subscription.tier === 'ENTERPRISE' && (
        <div className="info-box">
          <p>🎉 You're on the ENTERPRISE plan with unlimited access to all features!</p>
        </div>
      )}
    </div>
  );
}

export default CompanySubscription;